import React, { Component } from 'react'

// redux 
import { connect } from 'react-redux'
import ReportActions from '../../redux/component_select_report/actions'

// ui
import { Button } from 'antd'

// subcomponent
import HeadBar from './headbar'
import ListReports from './list_reports'
import Paginate from './paginate'

// props
// onSuccess(selectList): Khi nguoi dung lua chon
// onCancel(): khi nguoi dung khong chon
// initReport: khoi tao select
// tier_created: tier cua bao cao
class ComponentSelectReport extends Component {
    componentDidMount() {
        if (Array.isArray(this.props.initReport)) {
            this.props.updateSelectedReport(this.props.initReport)
            this.props.loadListReport({})
            this.props.updateTierCreated(this.props.tier_created)
        }
    }

    componentWillReceiveProps = nextProps => {
        if (nextProps.tier_created !== this.props.tier_created)
            this.props.updateTierCreated(nextProps.tier_created)
        if (
            Array.isArray(nextProps.initReport) &&
            nextProps.initReport !== this.props.initReport
        ) {
            console.log('componentWillReceiveProps abc', nextProps)

            this.props.updateSelectedReport(nextProps.initReport)
            this.props.loadListReport({})
        }


    }

    _onClickOk = () => {
        console.log("Click ok")

        this.props.onSuccess(this.props.selectedReport)
        this.props.updateTextSearch('')
        this.props.searchReport()
        this.props.updateSelectedReport([])
    }

    _onClickCancel = () => {
        this.props.onCancel()
    }

    render() {
        return (
            <div className="ComponentSelectReport" style={{ width: '100%' }}>
                <HeadBar />
                <ListReports />

                <div className="ButtonAction">
                    <Button
                        style={{ marginRight: 15 }}
                        type="primary"
                        onClick={() => this._onClickOk()}
                    >
                        Chọn tài liệu
                    </Button>

                    <Button type="danger" onClick={this._onClickCancel}>
                        Huỷ
                    </Button>

                    <Paginate />
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        selectedReport: state.component_select_report.selectedReport,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        loadListReport: params => {
            dispatch(ReportActions.action.loadListReport(params))
        },
        updateSelectedReport: reports => {
            dispatch(ReportActions.action.updateSelectedReport(reports))
        },
        updateTextSearch: textSearch => {
            dispatch(ReportActions.action.updateTextSearch(textSearch))
        },
        searchReport: () => {
            dispatch(ReportActions.action.searchReport())
        },
        updateTierCreated: tier_created => {
            dispatch(ReportActions.action.updateTierCreated(tier_created))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ComponentSelectReport)